export const squareFormContainerId = 'square-card-container';
